import { Column } from '@/components'
import { toThemePixels } from '@/utils'
import styled from 'styled-components'

export const PoaTitleContainer = styled(Column)`
  gap: ${toThemePixels(2)};
  margin-bottom: ${toThemePixels(8)};
  margin-top: ${toThemePixels(8)};
`
